export const TRANSCRIPTION_LOADING_TEXTS = [
  'Enviando...',
  'Processando sua gravação...',
  'Identificando documentos...',
  'Transcrevendo...',
  'Refinando transcrição...',
  'Quase finalizado!',
];

export const LOADING_CONFIGS = {
  transcription: {
    texts: TRANSCRIPTION_LOADING_TEXTS,
    interval: 4000,
    loop: false,
  },
} as const;
